import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { EndpointDetailsDataProviderFactory } from '../factory/EndpointDetailsDataProviderFactory';
import { EndpointDetailsBaseDataProvider } from '../dataProvider/EndpointDetailsBaseDataProvider';
import { EndpointDetailsWebComponentSchema } from '../types';

export class EndpointDetailsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EndpointDetailsDataProviderFactory;
  public dataProvider: EndpointDetailsBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new EndpointDetailsDataProviderFactory(),
    });
  }

  async getEndpointDetails(endpointId: string): Promise<EndpointDetailsWebComponentSchema> {
    return this.dataProvider.getEndpointDetails(endpointId);
  }
}
